import { API_URL } from '../../utils/constants';

import request from '../request';
import { stringsToNull, stringsToNullForId } from '../../utils/misc';

export default {
  get: async (id) => {
    return request(`${API_URL}/warehouses/${id}`, 'get', {}, {});
  },
  getSvila: async (id) => {
    return request(`${API_URL}/warehouses/4d13e3a6-40fc-43de-852d-8485281f89bc`, 'get', {}, {});
  },
  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/warehouses/${id}`, 'put', body, {});
  },
  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/warehouses/`, 'post', body, {});
  },
  delete: async (id) => {
    return request(`${API_URL}/warehouses/${id}`, 'delete', {}, {});
  },
};
